module.exports = __webpack_public_path__ + "img/sport-31-@3x.4156c172.png";